// 删除人员
import { Dialog, Toast, Notify } from 'vant'
export const useDelPersonnel = (method, calback) => {
  const handleDelPersonnelClick = (id) => {
    Dialog.confirm({
      title: '删除',
      message: '确定要永久删除该条记录？'
    })
      .then(() => {
        // on confirm
        delPersonnel(id)
      })
      .catch(() => {
        // on cancel
      })
  }
  const delPersonnel = async (id) => {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      overlay: true,
      message: '请稍后...'
    })
    try {
      const { status } = await method({ empId: id })
      if (status === 200) {
        Notify({ type: 'success', message: '删除成功' })
        calback()
      } else {

      }
      Toast.clear()
    } catch {
      Toast.clear()
    }
  }
  return {
    handleDelPersonnelClick
  }
}
